import PostModule from './containers/postModule'

export {default as PostModuleLayout} from './components/postModuleLayout'

export default PostModule
